// modules
import { useCallback, useState } from "react";

import { Form } from "antd";

// service calls
import { fetchUserOffer, redeemOffers } from "services/api/offerRedemption";
// components
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";

// constants and types

import { FormInstance } from "antd/es/form/Form";

type AdhocReportPropTypes = {
	findOfferSubmit: () => void;
	redeemOfferSubmit: () => void;
	codeCountError: boolean;
	loading: boolean;
	form: FormInstance;
	cardNumber: string;
	member?: boolean;
	receipt?: string;
	offer?: SelectObject;
	offerLabel?: string;
	fetchOfferData?: [];
	redeemData?: [];
	fetchOfferDataHolder?: [];
	foundOffers: boolean;
	remarks?: string;
	offerSelect: SelectObject[];
	handleOffer: (s: SelectObject) => void;
	handleRemarks: (s: string) => void;
	handleCheckboxChange: (s: boolean) => void;
	handleCardNumber: (s: string) => void;
	handleReceipt: (s: string) => void;
	checkedItems: any;

	handleSelectAll: (checked: boolean) => void;
	isAllSelected: boolean;
	handleClearAll: (message?: string) => void;
};

interface SelectObject {
	label: string;
	value: string;
	key: string;
}

export function useOfferRedemptionPage(): AdhocReportPropTypes {
	const [form] = Form.useForm();

	const [loading] = useState<boolean>(false);
	const [codeCountError, setCodeCountErr] = useState<boolean>(false);
	const [foundOffers, setFoundOffers] = useState<boolean>(false);
	const [cardNumber, setCardNumber] = useState<string>("");
	const [receipt, setReceipt] = useState<string>("");
	const [offer, setOffer] = useState<SelectObject>();
	const [offerLabel, setOfferlabel] = useState<string>();
	const [fetchOfferData, setFetchOfferData] = useState<[]>();
	const [fetchOfferDataHolder, setFetchOfferDataHolder] = useState<[]>();
	const [remarks, setRemarks] = useState<string>("");
	const [offerSelect, setOfferSelect] = useState<SelectObject[]>([]);
	const [redeemData, setRedeemData] = useState<any[]>([]);
	const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
	const [isAllSelected, setIsAllSelected] = useState<boolean>(false);

	const handleCardNumber = useCallback(
		(num: string) => {
			setCardNumber(num);
			if (!num) {
				setCodeCountErr(true);
			}
			setCodeCountErr(false);
		},
		[cardNumber]
	);

	const handleReceipt = useCallback(
		(val: string) => {
			setReceipt(val);
		},
		[receipt]
	);

	const handleRemarks = useCallback(
		(val: string) => {
			setRemarks(val);
		},
		[remarks]
	);

	const handleOffer = useCallback(
		(val: SelectObject) => {
			setOffer(val);

			const filterData: any = fetchOfferDataHolder?.filter((x: any) => x?.offer_id === val);
			const findLabel: any = offerSelect?.find((x: any) => x?.value === val);

			setOfferlabel(findLabel?.label);
			setFetchOfferData([]);
			setFetchOfferData(filterData);
			setRedeemData([]);
			setCheckedItems({});
		},
		[setOffer, fetchOfferData]
	);

	const handleSelectAll = useCallback(
		(checked: boolean) => {
			const newCheckedItems: { [key: string]: boolean } = {};
			const newRedeemData: string[] = [];

			if (checked && fetchOfferData) {
				fetchOfferData.forEach((item: any) => {
					newCheckedItems[item.voucher_no] = true;
					newRedeemData.push(item.voucher_no);
				});
			}

			setIsAllSelected(checked);
			setCheckedItems(newCheckedItems);
			setRedeemData(newRedeemData);
		},
		[fetchOfferData]
	);

	const handleCheckboxChange = (e: any) => {
		const voucherNo = e.target["data-props"]?.voucher_no;
		const isChecked = e.target.checked;

		if (isChecked) {
			setRedeemData((list) => [...(list || []), voucherNo]);
		} else {
			setRedeemData((list) => list?.filter((item) => item !== voucherNo) || []);
			setIsAllSelected(false);
		}
		setCheckedItems((prev) => ({
			...prev,
			[voucherNo]: isChecked
		}));

		// Check if all items are selected after this change
		if (fetchOfferData) {
			const allChecked = fetchOfferData.every((item: any) => (item.voucher_no === voucherNo ? isChecked : checkedItems[item.voucher_no]));
			setIsAllSelected(allChecked);
		}
	};

	const resetFields = () => {
		setRemarks("");
		setCardNumber("");
		setReceipt("");
		setOffer(undefined);
		setOfferSelect([]);
		form.setFieldValue("offer", {});
		setRedeemData([]);
		setCodeCountErr(false);
		setIsAllSelected(false);
		handleSelectAll(false);
	};

	const handleClearAll = useCallback(
		(message?: string) => {
			form.resetFields();
			resetFields();
			setFetchOfferData([]);
			setFoundOffers(false);

			showModal(message || "All Fields has been cleared");
		},
		[resetFields]
	);

	const showModal = (title: string, error = false) => {
		CountDownModal({
			timer: 2,
			title,
			errorIcon: error
		});
	};
	const redeemOfferSubmit = async () => {
		const errorMessages: string[] = [];

		const errorFlags = {
			redeemData: redeemData.length <= 0,
			offer: !offer,
			receipt: !receipt,
			remarks: !remarks
		};
		if (errorFlags.offer) {
			errorMessages.push("Offer field is required.");
		}
		if (errorFlags.redeemData) {
			errorMessages.push("Select at least 1 offer to redeem");
		}

		if (errorFlags.receipt) {
			setCodeCountErr(true);
			errorMessages.push("Receipt field is required.");
		}
		if (errorFlags.remarks) {
			setCodeCountErr(true);
			errorMessages.push("Remarks field is required.");
		}

		if (errorMessages.length > 0) {
			showModal(errorMessages[0], true);
			return;
		}
		const voucherList: any = [];
		fetchOfferData?.map((x: any) => {
			const voucherDetails: any = offerSelect.find((ele: any) => ele.value == x?.user_offer_id);

			voucherList.push({
				offer_ID: x?.user_offer_id,
				code: voucherDetails?.actiatlas_offer_idve
			});
		});

		const payload = {
			card_no: cardNumber,
			receipt,
			remarks,

			redemption_voucher_lists: redeemData
		};

		try {
			const { data: reportsData } = await redeemOffers(payload);
			const { /* errors, */ data /* , message */ } = reportsData;

			showModal("CSV report successfully generated.");
			window.open(data.file_url, "_blank");
			form.resetFields();
			resetFields();
			setFetchOfferData([]);
			setFoundOffers(false);
		} catch (error) {
			showModal("Something went wrong!", true);
		}
	};
	const findOfferSubmit = async () => {
		const payload = {
			card_no: cardNumber
		};
		setFetchOfferData([]);

		setOfferlabel(offer?.label);
		const showModal = (title: string, error = false) => {
			CountDownModal({
				timer: 3,
				title,
				errorIcon: error
			});
		};
		const requiredMsg = "Please fill all required fields.";
		const wrong = "Something went wrong.";
		if (!cardNumber) {
			setCodeCountErr(true);
			showModal(requiredMsg, true);
			return;
		}
		try {
			const { data: reportsData } = await fetchUserOffer(payload);

			const { errors, data } = reportsData;

			if (!data) {
				showModal(errors[0].message || wrong, true);
				return;
			}
			const offerData: SelectObject[] = [];
			offerData.push({
				label: "< Select an offer >",
				value: "",
				key: "0"
			});
			data.voucher_summary.map((res: any, i: number) => {
				offerData.push({
					label: res.voucher_type_name,
					value: res.offer_id,
					key: `${res.offer_id}-${i}`
				});
			});

			setOfferSelect(offerData);
			setOffer(offerData[0]);
			setFetchOfferData([]);
			setFetchOfferDataHolder(data.active_voucher_lists);

			setFoundOffers(true);
			setCodeCountErr(false);
		} catch (e: any) {
			showModal(e.response.data.errors[0].message || wrong, true);
		}
	};

	return {
		loading,
		form,
		codeCountError,
		handleOffer,
		cardNumber,
		foundOffers,
		offerLabel,
		handleCardNumber,
		handleRemarks,
		handleReceipt,
		handleCheckboxChange,
		// isRedeemed,
		receipt,
		offer,
		offerSelect,
		fetchOfferData,
		fetchOfferDataHolder,
		remarks,
		findOfferSubmit,
		redeemOfferSubmit,
		checkedItems,
		handleSelectAll,
		isAllSelected,
		handleClearAll
	};
}
